<app-back-header 
  [headerText]="'Torna ai Corrispettivi'" 
  (backAction)="onCancel()" 
  class="sticky-top">
</app-back-header>

<div>
  <div class="row justify-content-center">

    <h3 class="mb-3">Dettaglio Corrispettivi:</h3>

    <div>
      
      <div *ngIf="isLoading" class="d-flex justify-content-center py-5">
        <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
      </div>

      <form [formGroup]="receiptForm" *ngIf="!isLoading">
        
        <mat-card class="custom-card mb-3">
          <mat-card-header>
            <mat-card-title class="mb-2 d-flex align-items-center">
              <mat-icon class="me-2">settings_remote</mat-icon>Dati Dispositivo & Invio
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="mt-3">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Matricola RT (Id Dispositivo)</mat-label>
                  <input matInput formControlName="device_id" readonly>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Progressivo Invio</mat-label>
                  <input matInput type="number" formControlName="progressive_number" readonly>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Formato File</mat-label>
                  <!-- <mat-select formControlName="format">
                    <mat-option *ngFor="let opt of formatOptions" [value]="opt.code">{{opt.name}}</mat-option>
                  </mat-select> -->
                  <input matInput type="string" formControlName="format" readonly>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Data Rilevazione (Chiusura)</mat-label>
                  <input 
                    matInput 
                    readonly 
                    [value]="formatFormDate('detection_date')">
                  <!-- <mat-datepicker-toggle matSuffix [for]="pickDet"></mat-datepicker-toggle> -->
                  <!-- <mat-datepicker #pickDet></mat-datepicker> -->
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Data Ora Trasmissione</mat-label>
                  <input 
                    matInput 
                    readonly 
                    [value]="formatFormDate('transmission_date')">
                  <!-- <mat-datepicker-toggle matSuffix [for]="pickTrans"></mat-datepicker-toggle> -->
                  <!-- <mat-datepicker #pickTrans></mat-datepicker> -->
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="custom-card mb-3">
          <mat-card-header>
            <mat-card-title class="mb-2 d-flex align-items-center">
              <mat-icon class="me-2">euro_symbol</mat-icon>Riepilogo Importi & IVA
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="mt-3">
            <div class="row">
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Totale Lordo (Ammontare)</mat-label>
                  <input matInput type="number" formControlName="amount" readonly>
                  <span matTextPrefix>€&nbsp;</span>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Aliquota IVA (%)</mat-label>
                  <input matInput type="number" formControlName="vat_percentage" readonly>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Imposta (IVA)</mat-label>
                  <input matInput type="number" formControlName="vat_amount" readonly>
                  <span matTextPrefix>€&nbsp;</span>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="custom-card mb-3">
          <mat-card-header>
            <mat-card-title class="mb-2 d-flex align-items-center">
              <mat-icon class="me-2">payments</mat-icon>
              <span>Dettaglio Pagamenti</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="mt-3">
            <div class="row">
              <div class="col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>N. Documenti Emessi</mat-label>
                  <input matInput type="number" formControlName="n_docs" readonly>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Pagato Contanti</mat-label>
                  <input matInput type="number" formControlName="paid_cash" readonly>
                  <span matTextPrefix>€&nbsp;</span>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Pagato Elettronico</mat-label>
                  <input matInput type="number" formControlName="paid_electronic" readonly>
                  <span matTextPrefix>€&nbsp;</span>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Sconti Applicati</mat-label>
                  <input matInput type="number" formControlName="discount" readonly>
                  <span matTextPrefix>€&nbsp;</span>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <div class="d-flex justify-content-end gap-3 mt-4 pb-3">
          <button mat-stroked-button type="button" (click)="onCancel()">
            <mat-icon>chevron_left</mat-icon>Torna alla tabella</button>
          <!-- <button mat-raised-button color="primary" type="submit" [disabled]="receiptForm.invalid">
            <mat-icon>save</mat-icon> Salva Modifiche
          </button> -->
        </div>

      </form>
    </div>
  </div>
</div>